export enum ButtonTypeEnum {
  PRIMARY,
  SECONDARY,
  TERTIARY,
  TERTIARY_NGPORTAL
}

export enum ButtonSize {
  SMALL = 'small',
  BIG = 'big'
}
